const fileToDataUrl = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = () => resolve(String(reader.result || ''))
    reader.onerror = () => reject(new Error('Failed to read file'))

    reader.readAsDataURL(file)
  })

const filesToDataUrls = async fileList => {
  const files = Array.from(fileList || [])
  if (!files.length) return []

  return Promise.all(files.map(fileToDataUrl))
}

export { fileToDataUrl, filesToDataUrls }
